var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"international-operations"},[_c('CountrySection',{model:{value:(_vm.currentCountry),callback:function ($$v) {_vm.currentCountry=$$v},expression:"currentCountry"}}),_c('PriceSection',{attrs:{"current-country":_vm.currentCountry}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }